import { Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';

import { PageService } from '@services/page.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false
})
export class AppComponent {

  constructor(
    private titleService: Title,
    private pageService: PageService
  ) { }

  tituloToolbar: string = '';
  title = 'gma-ui';
  @ViewChild('drawer') drawer: MatSidenav;
  drawerOpened: boolean = false;

  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.titleService.setTitle("GMA");
    this.subscriptions.push(this.pageService.openSidenav.subscribe(() => this.drawer.toggle()));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
